import { render, staticRenderFns } from "./translation.vue?vue&type=template&id=449d6850&scoped=true"
import script from "./translation.vue?vue&type=script&lang=js"
export * from "./translation.vue?vue&type=script&lang=js"
import style0 from "./translation.vue?vue&type=style&index=0&id=449d6850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449d6850",
  null
  
)

export default component.exports